<template>
  <div class="closed">
    <p class="title">
      <span v-html="surveyQuestion.longCaption" />
    </p>
    <RadioGroup
      v-model="surveyForm.entryCode"
      :items="mappedItems"
      @input="onInput(surveyForm.entryCode)"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import RadioGroup from '../../common/RadioGroup'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'Closed',
  components: {
    RadioGroup,
  },
  data() {
    return {
      surveyForm: {
        entryCode: '',
      },
    }
  },
  created() {
    this.setInputName(this.surveyQuestion.inputName)
    this.$emit('setValid', !!this.surveyForm.entryCode)
  },
  computed: {
    ...mapGetters(['surveyQuestion']),
    mappedItems() {
      return this.surveyQuestion.responses.map((s) => ({
        value: s.id,
        text: s.caption,
      }))
    },
  },
  methods: {
    ...mapActions(['setInputName', 'setAnswer']),
    onInput(entryCode) {
      this.setAnswer(entryCode)
      this.$emit('setValid', true)
    },
  },
}
</script>

<style scoped lang="postcss">
.closed {
  text-align: left;
}

.title {
  margin: 0;
  color: #191919;
}

@media (max-width: 768px) {
  .title {
    padding-bottom: 15px;
    font-size: 16px;
    line-height: 20px;
  }
}

@media (min-width: 768px) {
  .title {
    padding-bottom: 30px;
    font-size: 25px;
    line-height: 1.2;
  }
}
</style>
